import "../../../Events";

/** @namespace GIS.Map.Control */
NS("GIS.Map.Control");

/**
 * @class
 * @extends Events
 */
GIS.Map.Control.Base = Class(Events, /** @lends GIS.Map.Control.Base.prototype */ {
    /**
     * @type {GIS.UI.Map}
     * @protected
     */
    map: null,
    /**
     * @type {Element|$<Element>|string}
     */
    target: null,
    /**
     * @param {GIS.UI.Map} map
     * @param {Object} [options]
     */
    initialize: function(map, options) {
        _.merge(this, options);

        this.map = map;
    },
    /**
     * @returns {GIS.Map.Control.Base}
     */
    destroy: function() {
        this.map = null;

        this.emit("destroy").off();
        return this;
    },
    /**
     * @returns {GIS.UI.Map}
     */
    getMap: function() {
        return this.map;
    }
});
